export default "__VITE_ASSET__31dc342e__"